import { useState } from 'react'
import { Menu } from 'lucide-react'
import Sidebar from './Sidebar'
import { LanguageToggle } from './LanguageToggle'

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const close = () => setSidebarOpen(false)

  return (
    <div className="flex min-h-screen" style={{ background: '#0f1117' }}>

      {/* ── DESKTOP sidebar ── always in flow, hidden on mobile ── */}
      <div className="hidden lg:block flex-shrink-0">
        <Sidebar />
      </div>

      {/* ── MOBILE sidebar ── fixed overlay, off-screen by default ── */}
      <>
        {/* Backdrop */}
        <div
          onClick={close}
          className={`
            lg:hidden fixed inset-0 z-40
            transition-opacity duration-300
            ${sidebarOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
          `}
          style={{ background: 'rgba(0,0,0,0.65)' }}
        />

        {/* Drawer */}
        <div
          className={`
            lg:hidden fixed top-0 left-0 h-full z-50
            transform transition-transform duration-300 ease-in-out
            ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          `}
        >
          <Sidebar onClose={close} />
        </div>
      </>

      {/* ── Main content ── always full-width on mobile ── */}
      <div className="flex flex-col flex-1 min-w-0">

        {/* Mobile top bar */}
        <header
          className="lg:hidden flex items-center gap-3 px-4 py-3 sticky top-0 z-30"
          style={{ background: '#1a1d27', borderBottom: '1px solid #2d3148' }}
        >
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg transition-colors hover:bg-white/10"
            style={{ color: '#9ca3af' }}
            aria-label="Open menu"
          >
            <Menu size={20} />
          </button>
          <div className="flex items-center gap-2">
            <div
              className="w-6 h-6 rounded flex items-center justify-center text-white font-bold text-xs"
              style={{ background: '#6366f1' }}
            >
              O
            </div>
            <span className="text-white font-semibold text-sm">Otomator Admin</span>
          </div>
          <div className="ml-auto">
            <LanguageToggle />
          </div>
        </header>

        <header
          className="hidden lg:flex items-center justify-end px-6 py-3 sticky top-0 z-20"
          style={{ background: '#1a1d27', borderBottom: '1px solid #2d3148' }}
        >
          <LanguageToggle />
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-auto">
          <div className="p-4 sm:p-6 lg:p-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
